<nz-layout class="page-layout">
  <nz-sider
    class="page-layout-sidebar"
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    nzWidth="345px"
    [nzCollapsedWidth]="0"
  >
    <div class="sidebar-header">
      @if(isCollapsed){
      <img style="width: 50px" src="assets/logos/favicon.svg" alt="logo" />
      }@else {
      <img style="width: 137px" [src]="logoPath" alt="logo" />
      }
    </div>

    <div class="sidebar-content">
      <ng-content select="[sidebarContent]"></ng-content>
    </div>

    <div class="sidebar-footer">
      <ng-content select="[sidebarFooter]"></ng-content>
    </div>
  </nz-sider>

  <nz-layout class="page-layout-wrapper">
    <ng-content select="[header]"></ng-content>

    <nz-content class="page-layout-content">
      <ng-content select="[content]"></ng-content>
    </nz-content>
    <!-- <nz-footer>Ant Design ©2020 Implement By Angular</nz-footer> -->
    <ng-content select="[footer]"></ng-content>
  </nz-layout>
</nz-layout>
